"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventName = void 0;
const getEventName = (cacheName, action) => {
    return `cache_${cacheName}_${action}`;
};
exports.getEventName = getEventName;
//# sourceMappingURL=utils.js.map